var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("Loading", { ref: "loading" }),
      _vm._v(" "),
      _c("NotificationsSection"),
      _vm._v(" "),
      _c("RouterView")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }